import { toFormData } from "@king-ict/eupisi-ui/utils";
import { useSelector } from "react-redux";

import {
  createFromExistingInitialConversationDocument,
  createInitialConversationDocument,
  deleteInitialConversationDocument,
  getInitialConversationDocument,
} from "../../../api/kindergartenApi";
import InitialConversationUploadDocument from "../../../models/Questionnaire/InitialConversationUploadDocument";
import DocumentMethodsReturnType, {
  DocumentDownloadRemoveMethodReturnType,
} from "../../../models/Request/DocumentMethodsReturnType";
import InitialConversationQuestionDataItem from "../../../models/Request/InitialConversationQuestionDataItem";
import { RequestDocumentData } from "../../../models/Request/RequestDocumentData";
import { selectMainInfo } from "../../../slices/requestSlice";

interface Props {
  stateIndex: number;
  conversationItem: InitialConversationQuestionDataItem;
  onCloseDocumentsModal: () => void;
  onConfirmDocumentsModal: (
    documents: RequestDocumentData[],
    stateIndex: number
  ) => void;
  onRemoveDocumentFromList: (
    stateIndex: number,
    document: RequestDocumentData
  ) => void;
}

export function useInitialConversationDocuments(): DocumentDownloadRemoveMethodReturnType;
export function useInitialConversationDocuments(
  props: Props
): DocumentMethodsReturnType;
export function useInitialConversationDocuments(props?: Props) {
  const requestMainInfoState = useSelector(selectMainInfo);

  const handleDownloadDocument = (document: RequestDocumentData) => {
    if (document.fileID) {
      getInitialConversationDocument(document.fileID);
    }
  };

  const handleRemoveDocuments = (documents: RequestDocumentData[]) => {
    let ids = new Array<number>();
    documents.forEach((document) => {
      if (document.id) {
        ids.push(document.id);
      }
    });

    if (ids.length > 0) {
      deleteInitialConversationDocument(ids);
    }
  };

  if (props) {
    const {
      stateIndex,
      conversationItem,
      onCloseDocumentsModal,
      onConfirmDocumentsModal,
      onRemoveDocumentFromList,
    } = props;

    const handleCloseDocumentsModal = (documents: RequestDocumentData[]) => {
      handleRemoveDocuments(documents);

      onCloseDocumentsModal();
    };

    const handleConfirmDocumentsModal = (documents: RequestDocumentData[]) => {
      onConfirmDocumentsModal(documents, stateIndex);
    };

    const handleUploadDocuments = async (files: File[]) => {
      var documents = await createInitialConversationDocument(
        toFormData<InitialConversationUploadDocument>({
          requestUID: requestMainInfoState.uId,
          applicantParentOib: requestMainInfoState.applicantParentOib,
          childOib: requestMainInfoState.childOib,
          files: files,
          questionGroupQuestionId: conversationItem.questionGroupQuestionId,
        })
      );
      return documents;
    };

    const handleUploadExistingDocument = async (
      document: RequestDocumentData
    ) => {
      var docResult = await createFromExistingInitialConversationDocument(
        document.fileID!,
        document.origin,
        conversationItem.questionGroupQuestionId
      );
      return docResult;
    };

    const handleRemoveDocument = (document: RequestDocumentData) => {
      if (document.id) {
        const ids = [document.id];
        deleteInitialConversationDocument(ids);
      }
    };

    const handleRemoveDocumentFromList = (document: RequestDocumentData) => {
      onRemoveDocumentFromList(stateIndex, document);
      handleRemoveDocument(document);
    };

    return {
      handleCloseDocumentsModal,
      handleConfirmDocumentsModal,
      handleUploadDocuments,
      handleUploadExistingDocument,
      handleRemoveDocument,
      handleRemoveDocumentFromList,
      handleDownloadDocument,
      handleRemoveDocuments,
    };
  } else {
    return {
      handleDownloadDocument,
      handleRemoveDocuments,
    };
  }
}
